/* eslint-disable no-param-reassign */
import { util } from 'echarts';
import { ThemeParser } from '../../../core/theme';
import { normalizeToArray } from '../../../util/utils';

function preporcessGrid(option: Parameters<ThemeParser>[0]) {
  option.grid = normalizeToArray(option.grid || {});
}

function parseGrid(option: Parameters<ThemeParser>[0]) {
  const defaultMainGrid = {
    left: 16,
    top: 0,
    right: 16,
    height: 200
  };
  const defaultAttechedGrid = {
    height: 100
  };

  (option.grid as unknown as []).forEach((grid, index) => {
    if (grid?.id === 'mainGrid' || index === 0) {
      option.grid[index] = util.merge(util.clone(defaultMainGrid), grid, true);
    } else if (grid.id === 'AttchedGrid' || index > 0) {
      option.grid[index] = util.merge(util.clone(defaultAttechedGrid), grid, true);
    } else {
      /* empty */
    }
  });
}

export function gridThemeParse(...args: Parameters<ThemeParser>) {
  const [option] = args;
  preporcessGrid(option);
  parseGrid(option);
}
